import { isAdTemplateOffered } from "src/pages/ad-studio/components/is-ad-template-offered";
import { isInBrandScope, liveBrandIds } from "src/utils/brand-scope";
import type { AdStudioTemplateCard } from "src/pages/ad-studio/templates/types";

export type TemplateSelection = {
  ids: string[];
};

export type TemplateSelectionContext = {
  adStudioTemplateIds?: unknown;
};

export function templateSelectionToContext(selection: TemplateSelection): {
  adStudioTemplateIds?: string[];
} {
  return selection.ids.length > 0 ? { adStudioTemplateIds: selection.ids } : {};
}

export function templateSelectionFromContext(
  context: TemplateSelectionContext | null | undefined,
): TemplateSelection {
  if (!Array.isArray(context?.adStudioTemplateIds)) {
    return { ids: [] };
  }
  return {
    ids: [
      ...new Set(
        context.adStudioTemplateIds.filter(
          (id): id is string => typeof id === "string" && id.length > 0,
        ),
      ),
    ],
  };
}

export function selectAdStudioTemplateOptions(
  templates: AdStudioTemplateCard[],
  brandProfileId: string,
): AdStudioTemplateCard[] {
  return templates
    .filter(
      (template) =>
        isAdTemplateOffered(template) &&
        isInBrandScope(liveBrandIds(template.brandProfileAssignments), [
          brandProfileId,
        ]),
    )
    .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
}
